import { useMutation } from '@tanstack/react-query'

import useAppDispatch from '@/hooks/useAppDispatch'
import clientService from '@/lib/services/clientService'
import { setClientMetadata } from '@/redux/slices/clientMetadata'

export function useCreateClientMetadataMutation() {
  const dispatch = useAppDispatch()

  return useMutation({
    mutationFn: () => clientService.createClientMetadata(),
    onSuccess: (metadata) => {
      dispatch(setClientMetadata(metadata))
    },
  })
}
